import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastComponent } from './toast.component';
import { MatIconModule } from '@angular/material';

import { ToastService } from './toast.service';

@NgModule({
  declarations: [ToastComponent],
  entryComponents: [ToastComponent],
  providers: [ToastService],
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [ToastComponent]
})
export class ToastModule { }
